import _ from 'lodash'
import i18n from '@/i18n.js';

export default {
  carrito: state => {
    return _.cloneDeep(state.carrito);
  },
  preciosPrendas: state => {
    return state.carrito.productos.reduce(function (acc, val) { return acc + parseFloat(val.total); }, 0)

  },
  preciosReprocesos: state => {
    return state.carrito.reprocesos.reduce(function (acc, val) { return acc + parseFloat(val.total); }, 0)
  },
  totalUnidades: (state) => {
    return state.carrito.cantidad
  },
  precioUnitario: (state, getters) => {
    let precioUnitario = ((getters.preciosPrendas + getters.preciosReprocesos) / state.carrito.cantidad).toFixed(4)
    return isNaN(precioUnitario) ? 0 : precioUnitario;
  },
  hasSerigrafiaOTransfer: state => {
    if (state.carrito.nreprocesos.filter(r => r.t == "Serigrafia" || r.t == "Transfer").length)
      return true;
    return false;
  },
  hasPackUno: (state, getters, rootState, rootGetters) => {
    if (state.carrito.productos.some(r => r.PACK == 1 || r.pack == 1) && !rootGetters["modelo/isStaminaModel"])
      return true;
    return false;
  },
  idOfActualHasDesembolsadoPack: (state, getters) => {
    if (!getters.hasPackUno || !getters.reprocesosFilter.length) return null;

    let findReproceso = getters.reprocesosFilter.find(r => r.params.atributos.includes("esPrendaPackUno"))?.id
    if (findReproceso)
      return findReproceso

    return getters.reprocesosFilter?.[0]?.id;
  },
  actualModelo: (state) => state.carrito.modelo,
  sobrecosteCantidadExacta: state => state.sobrecosteCantidadExacta,
  tecnicaCantidadExacta: state => state.carrito.reprocesos.find(t => t.isExtraCantidadExacta),
  loadingCarrito: (state) => state.loading > 0,
  numReprocesos: (state) => state.carrito.reprocesos.length,
  numReprocesosSerigrafiaOrTransfer: (state) => state.carrito.reprocesos.filter(r => r.tecnica == "Serigrafia" || r.tecnica == "Transfer").length,
  unidadesOrdenadasPorArea: (state, getters, rootState) => ({ posicion, tecnica }) => {
    const items = state.carrito.productos
      .map((producto) => {
        // console.log(`[Prod ${index}] Buscando talla:`, producto.talla);

        const listaTallas = rootState.modelo?.modelInfo?.tallasInfo;
        if (!listaTallas) {
          console.error("❌ No encuentro rootState.modelo.modelInfo.tallasInfo");
          return undefined;
        }

        const tallaInfo = listaTallas.find(t => {
          // console.log(`Comparando '${t.Talla}' con '${producto.talla}'`);
          return t.Talla == producto.talla;
        });

        if (!tallaInfo) {
          console.warn(`⚠️ No encontré info para la talla: ${producto.talla}`);
          return undefined;
        }

        if (!tallaInfo.Posiciones) {
          console.warn("⚠️ La talla existe pero no tiene array de 'Posiciones'");
          return undefined;
        }

        const match = tallaInfo.Posiciones.find(p => {
          // console.log(`Check Pos: ${p.Posicion} === ${posicion} ?`, p.Posicion === posicion);
          // console.log(`Check Tec: ${tecnica} ? ${p.Tecnica} === ${tecnica}`, (!tecnica || p.Tecnica === tecnica));

          return p.Posicion === posicion && (!tecnica || p.Tecnica === tecnica);
        });

        if (!match) console.warn(`⚠️ Falló match de posición/técnica para talla ${producto.talla}`);

        return match;
      })
      .filter(Boolean); // Elimina undefined
    // Aquí está la magia: ordenamos una sola vez
    return items.sort((a, b) => {
      const areaA = (a.Ancho || 0) * (a.Alto || 0);
      const areaB = (b.Ancho || 0) * (b.Alto || 0);
      return areaA - areaB;
    });
  },

  // 2. GETTERS PÚBLICOS (Limpios y reutilizables)

  unidadMasPequeña: (state, getters) => (params) => {
    const ordenadas = getters.unidadesOrdenadasPorArea(params);
    return ordenadas.length ? ordenadas[0] : null;
  },

  unidadMasGrande: (state, getters) => (params) => {
    const ordenadas = getters.unidadesOrdenadasPorArea(params);
    return ordenadas.length ? ordenadas[ordenadas.length - 1] : null;
  },
  medidasMaximas: (state, getter, rootState) => ({ posicion, cm2, xaxis, yaxis, tecnica }) => {
  // console.log("🚀 ~ file: CarritoGetters.js:48 ~ tamañosTallas.forEach ~ xaxis", xaxis)
    // console.log("🚀 ~ file: CarritoGetters.js:48 ~ tamañosTallas.forEach ~ yaxis", yaxis)
    var tallas = []; // tallas en el carrito
    state.carrito.productos.forEach((element) => {
      tallas.push(element.talla);
    });

    // console.log("🚀 ~ file: CarritoGetters.js:36 ~ tallas", tallas)
    var tamañosTallas = []; // tamaños por talla y zona actual

    tallas.forEach(talla => {
      let actualSize = rootState.modelo.modelInfo.tallasInfo.find(t => t.Talla == talla)
      // console.log("🚀 ~ file: CarritoGetters.js:73 ~ actualSize:", actualSize)
      let findPosicion = actualSize.Posiciones.find(p => p.Posicion == posicion && (!tecnica || p.Tecnica == tecnica));

      if (!findPosicion) return;

      tamañosTallas.push({
        ...findPosicion,
        Descripcion: actualSize.TallaName + " - " + findPosicion.Descripcion
      });
    })

    if (!tamañosTallas.length) return null;

    // console.log("🚀 ~ file: CarritoGetters.js:42 ~ tamañosTallas", tamañosTallas)
    var response = [];
    tamañosTallas.forEach((element) => {

      // console.log("🚀 ~ file: CarritoGetters.js:48 ~ tamañosTallas.forEach ~ element.Ancho < xaxis", element.Ancho < xaxis)
      // console.log("🚀 ~ file: CarritoGetters.js:48 ~ tamañosTallas.forEach ~ element.Alto < yaxis", element.Alto < yaxis)
      if (cm2) {
        let area = element.Alto * element.Ancho / 100;
        if (area < cm2) {
          response.push(element);
        }
      } else {
        if (element.Alto < yaxis || element.Ancho < xaxis) {
          response.push(element);
        }
      }
    });
    // console.log("🚀 ~ file: CarritoGetters.js:46 ~ response", response)

    return response;
  },
  calcularPlanchado: state => state.calcularPlanchado,
  quantityByColor: state => {
    return state.carrito.productos.reduce((result, producto) => {
      const color = producto.color;
      const cantidad = parseInt(producto.cantidad);

      if (!result[color]) {
        // Si el color no existe en el objeto resultante, se agrega como nueva propiedad
        result[color] = cantidad;
      } else {
        // Si el color ya existe, se suma la cantidad
        result[color] += cantidad;
      }

      return result;
    }, {});
  },
  quantityByColorAndProduct: state => {
    return state.carrito.productos.reduce((result, producto) => {
      const color = producto.color;
      const cantidad = parseInt(producto.cantidad);

      if (!result[color]) {
        // Si el color no existe en el objeto resultante, se agrega como nueva propiedad
        result[color] = [];
      }



      result[color].push({ quantity: cantidad, size: producto.talla });

      return result;
    }, {});
  },
  manipuladosPrices: state => state.carrito.reprocesos.find(r => r.t == "Manipulados" || r.isManipulado)?.prices,


  comercialCart: (state, getter, rootState) => rootState.config.userOfClient ? state.comercialCart : [],
  countComercialCart: state => state.comercialCart.length,
  clientCart: state => state.clientCart,
  countClientCart: state => state.clientCart.length,
  totalClientCart: state => {
    return state.clientCart.reduce((total, articulo) => {
      return total + articulo.total;
    }, 0)
      .toFixed(2);
  },

  // Carrito que usar dependiendo si es un comercial o un cliente normal
  actualCart: (state, getter, rootState, rootGetters) => rootGetters['config/activeComercial'] ?
    state.comercialCart ?? [] : state.clientCart ?? [],
  totalActualCart: (state, getter) => getter.actualCart
    .reduce((total, reproceso) => {
      return total + reproceso.total;
    }, 0)
    .toFixed(2),

  completeCart: state => state.completeCart,
  lastCart: state => state.lastCart,
  colorCode: state => state.carrito?.colorCode,
  sortColorAvalibleAndWithQuantity: (state, getters, rootState, rootGetters) => {
    // Ordenamos las bolas de colores
    let colorAvalible = rootGetters['modelo/colorAvalible'];
    let quantityByColor = getters.quantityByColor;
    let colorAvalibleAndWithQuantity = [];
    colorAvalible.forEach(color => {
      let quantity = quantityByColor?.[color.code];
      if (quantity) {
        colorAvalibleAndWithQuantity.push({ ...color, quantity: quantity });
      }
    });

    return colorAvalibleAndWithQuantity;
  },
  cartHasProducts: state => state.carrito?.productos?.length > 0 && state.carrito?.productos?.some(p => p.cantidad > 0),
  soloBlancoEnCarritoSublimacion: (state, getter, rootState, rootGetters) => state.carrito.productos.length >= 1 && state.carrito.productos.every(p => p.color == "01") && rootGetters['modelo/sublimacionSoloBlanco'],
  /* The `listColorInCart` getter is returning an array of colors present in the
  `state.carrito.productos` array. It maps over each product in the cart and extracts the `color`
  property from each product, creating an array of colors used in the products currently in the
  cart. */
  listColorInCart: state => {
    const colors = [];
    state.carrito.productos.forEach(p => {
      if (!colors.includes(p.color)) {
        colors.push(p.color);
      }
    });
    return colors;
  },
  shippingAddress: state => state.shippingAddress,
  hasErrorInCart: (state, getter) => {
    let hasErrorInCart = state.carrito?.reprocesos?.some(r => r.error) ?? false

    if (hasErrorInCart) return true;

    return getter.hasTecnicaNoCalcular;
  },
  hasTecnicaNoCalcular: (state, getter, rootState, rootGetter) => {
    return state.carrito?.reprocesos?.some(r => {
      const extraInfoTecnica = rootGetter["modelo/getFilteredTecnicasExtra"](r.posicion, r.tecnica.replace("Stm", ""));
      console.log("🚀 ~ file: CarritoGetters.js:228 ~ r.tecnica:", r.tecnica.replace("Stm", ""))
      console.log("🚀 ~ file: CarritoGetters.js:228 ~ r.posicion:", r.posicion)
      console.log("🚀 ~ file: CarritoGetters.js:228 ~ extraInfoTecnica:", extraInfoTecnica)
      return extraInfoTecnica?.isTecnicaNoCalcular;
    }) ?? false;
  },
  sortedReprocesosByIdWithNotes: state => state.carrito?.reprocesos?.map(r => {
    // Si la técnica es manipulados, o planchado o cantidad exacta, no hacemos nada
    if (r.tecnica == "Manipulados" || r.tecnica == "Manipulacion" || r.tecnica == "Planchado" || r.tecnica == "CantidadExacta") {
      return r;
    }

    // Obtenemos params del reproceso y pasamos a json el string de atributos
    const params = r.params;
    const atributos = JSON.parse(params.atributos);

    // Atributos debe ser un array, y contener al menos un elemento
    if (!Array.isArray(atributos) || atributos.length === 0) {
      return r;
    }

    // Recuperamos el primer elemento
    const primerAtributo = atributos[0];

    let exclusionList = ['nreprocesos', 'prendas', 'esPrendaPackUno', 'esPackUno', 'isProveedor', 'felpa', 'tipo', 'isTransferSerigrafico', 'isTransferDigital', 'fondoOscuro'];

    // Comprobamos que el primer elemento existe, si existe, parseamos cada una de sus propiedades eliminando aquellas que sean false o tengan el valor 0
    if (primerAtributo) {
      const notes = Object.entries(primerAtributo).reduce(function (acc, [key, value]) {
        if (value && value > 0 && !exclusionList.some(exclusion => key.includes(exclusion))) {

          if (r.tecnica == "Impresion" && key.includes("idTamImpresion")) {
            acc.push({ key: "tamano", value: i18n.t("configuration.ImpresionDirecta.Size" + value) });
          }
          else if (key == "tintaNegra") {
            acc.push({ specialkey: i18n.t('configuration.Serigrafia.Usar tinta negra'), value: i18n.t("presupuesto.fichaReprocesos.params." + value) });
          }
          else if (typeof value == "boolean") {
            acc.push({ key, value: i18n.t("presupuesto.fichaReprocesos.params." + value) });
          }
          else if (key == "idTipoTinta") {
            acc.push({ key, value: i18n.t("configuration.Tintas.Tinta" + value) });
          }
          else if (key == "maxWidth" || key == "maxHeight") {
            acc.push({ key, value: value + " mm" });
          }
          else if (key == "tamanocm2Digital" || key == "tamanoCm2Doming") {
            acc.push({ key, value: value + " cm2" });
          }
          else if (key == "typeTermograbado") {
            acc.push({ key, value: i18n.t("configuration.CalculoPrecios.Termografia." + value) });
          }
          else {
            acc.push({ key, value });
          }
        }
        return acc;
      }, []);

      return {
        ...r,
        notes
      }
    }
  }).sort((a, b) => a.id - b.id),

  reprocesosFilter: state => state.carrito.reprocesos
    .filter(
      r =>
        !r.tecnica.includes("Manipulacion") &&
        !r.tecnica.includes("Etiquetas") &&
        !r.tecnica.includes("Planchado") &&
        !r.isExtraCantidadExacta
  ),
  infoTecnicaActualZone: state => state.infoTecnicaActualZone

};

